import { useEffect, useMemo } from 'react';
import { getStripeClient } from '../utils/stripeClient';
import { getPaymentSettings, PaymentSettings } from '../apis/paymentSettingApi';
import { useSessionStore } from '../stores';

export function useStripeClient() {
  const paymentSettings = useSessionStore.use.paymentSettings();
  const setPaymentSettings = useSessionStore.use.setPaymentSettings();

  useEffect(() => {
    if (!paymentSettings) {
      getPaymentSettings().then((settings: PaymentSettings) => {
        setPaymentSettings(settings);
      });
    }
  }, []);

  return useMemo(() => {
    if (!paymentSettings?.stripePublishableKey || !paymentSettings?.stripeAccountId) return null;

    return getStripeClient({
      apiKey: paymentSettings.stripePublishableKey,
    });
  }, [paymentSettings?.stripeAccountId, paymentSettings?.stripePublishableKey]);
}
